import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Trace",
    component: () => import("../views/Home.vue")
  },
  {
    path: "/productTrackInfo",
    name: "TraceTianjin",
    component: () => import("../views/TraceTianjin.vue")
  },
  {
    path: "/farmquality",
    name: "Farmquality",
    component: () => import("../views/FarmQuality.vue"),
    meta: {
      title: "食品安全检测报告"
    }
  },
  {
    path: "/qualitystandard",
    name: "qualitystandard",
    component: () => import("../views/QualityStandard.vue"),
    meta: {
      title: "验收标准"
    }
  },
  {
    path: "/tracetagdetail",
    name: "tracetagdetail",
    component: () => import("../views/TraceTagDetail.vue"),
    meta: {
      title: "商品溯源信息"
    }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
